import styled from "styled-components";

export const ErrorMessage = styled.p`
  text-align: center;
  color: black;
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const MainHeaderContainer = styled.header`
  color: #fff;
  padding: 15px 40px;
  height: 80px;
  background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 4;
`;


export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  font-family: "Roboto";
  position: relative;
  z-index: 3;
  height: 100%; /* Yeni eklendi: Container'ı 100% yükseklikte ayarla */
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
`;

export const Logo = styled.img`
  width: 200px;
  height: 30px;
  position: relative;
  z-index: 4;
  cursor: pointer;
`;
